import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f41cf0b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mail"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "response"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Message", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recipient" }, "TO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  value: "hello@mackboudreau.com",
  id: "recipient",
  disabled: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sender" }, "FROM", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "content" }, "BODY", -1))
const _hoisted_9 = { class: "content__container" }
const _hoisted_10 = ["maxlength"]
const _hoisted_11 = { class: "count" }
const _hoisted_12 = { class: "button__container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-paper-plane" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Send Message")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!

  return (_openBlock(), _createBlock(_Transition, { duration: 300 }, {
    default: _withCtx(() => [
      (_ctx.showMail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", null, [
                _createVNode(_Transition, {
                  duration: 200,
                  name: "fade"
                }, {
                  default: _withCtx(() => [
                    (_ctx.result)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_lottie_animation, {
                            path: this.result.icon,
                            class: _normalizeClass(["icon", this.result.type]),
                            loop: this.result.type == 'loading' ? true : false,
                            width: this.result.size,
                            height: this.result.size
                          }, null, 8, ["path", "class", "loop", "width", "height"]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["message", this.result.type])
                          }, [
                            _createElementVNode("h3", null, _toDisplayString(this.result.title), 1),
                            _createElementVNode("span", null, _toDisplayString(this.result.subtitle), 1),
                            (_ctx.result.type != 'loading')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "button button__small button__gray",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.hide()))
                                }, " Close "))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  ref: "from",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.from) = $event)),
                  placeholder: "you@email.com",
                  id: "sender"
                }, null, 512), [
                  [_vModelText, _ctx.from]
                ]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "content",
                    maxlength: _ctx.maxMessageBody,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body) = $event)),
                    placeholder: "Your message"
                  }, null, 8, _hoisted_10), [
                    [_vModelText, _ctx.body]
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.maxMessageBody - this.body.length) + "/400", 1)
                ]),
                _createVNode(_component_vue_recaptcha, {
                  sitekey: "6LfMqVUhAAAAAINETaDdlw8ZTCPjmrdyxYa_nxdN",
                  size: "normal",
                  onVerify: _ctx.challengeCompleted,
                  onExpired: _ctx.challengeExpired,
                  onError: _ctx.challengeError
                }, null, 8, ["onVerify", "onExpired", "onError"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    class: "button button__small button__gray",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (this.hide()))
                  }, " Cancel "),
                  _createElementVNode("a", {
                    class: _normalizeClass(["button cta", { disabled: !_ctx.isComplete() }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (this.submit()))
                  }, _hoisted_15, 2)
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "overlay",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (this.hide()))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}